import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-common/src/async.tsx';
import {
	setPerformanceMarkLoadStart,
	setPerformanceMarkLoadEnd,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/performance-marks/index.tsx';
import { lazyAfterPaint, lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { SidebarFiltersGlobal as SidebarFiltersGlobalType } from './ui/global-scope/index.tsx';
import type { SidebarFiltersLegacy as SidebarFiltersLegacyType } from './ui/main.tsx';

// Legacy GIN Sidebar
const LazySidebarFiltersLegacy = lazyAfterPaint<typeof SidebarFiltersLegacyType>(() => {
	setPerformanceMarkLoadStart();
	return import(/* webpackChunkName: "async-sidebar-filters" */ './index').then((bundle) => {
		setPerformanceMarkLoadEnd();
		return bundle;
	});
});

const AsyncSidebarFiltersLegacy = memo(() => (
	<SidebarBoundary id="filters">
		<LazySidebarFiltersLegacy />
	</SidebarBoundary>
));

export default AsyncSidebarFiltersLegacy;

// Global-scope NIN sidebar
const LazyAfterPaintSidebarFiltersGlobal = lazyAfterPaint<typeof SidebarFiltersGlobalType>(() => {
	setPerformanceMarkLoadStart();
	// using direct path instead of `index` because webpack will combine multiple chunks from same file
	return import(/* webpackChunkName: "async-sidebar-filters-global" */ './ui/global-scope').then(
		(bundle) => {
			setPerformanceMarkLoadEnd();
			return bundle.SidebarFiltersGlobal;
		},
	);
});

const LazyForPaintSidebarFiltersGlobal = lazyForPaint<typeof SidebarFiltersGlobalType>(() => {
	setPerformanceMarkLoadStart();
	// using direct path instead of `index` because webpack will combine multiple chunks from same file
	// eslint-disable-next-line jira/import/webpack-magic-comment-entries
	return import(/* webpackChunkName: "async-sidebar-filters-global" */ './ui/global-scope').then(
		(bundle) => {
			setPerformanceMarkLoadEnd();
			return bundle.SidebarFiltersGlobal;
		},
	);
});

export const AsyncSidebarFiltersGlobal = memo(() => (
	<SidebarBoundary id="filters-global">
		<LazyAfterPaintSidebarFiltersGlobal />
	</SidebarBoundary>
));

export const AsyncForPaintSidebarFiltersGlobal = memo(() => (
	<SidebarBoundary id="filters-global">
		<LazyForPaintSidebarFiltersGlobal />
	</SidebarBoundary>
));
